if (!customElements.get('vendor-search')) {
  class VendorSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.checkboxElements = [...this.querySelectorAll('.checkbox-container')];
    }
    
    handleInput(event) {
      this.checkboxElements.forEach((element) => {
        element.removeAttribute('hidden');
        element.querySelector("label > span:first-child").innerHTML = 
          element.querySelector("label > span:first-child").innerHTML.replaceAll('<mark>', '').replaceAll('</mark>', '');
        if (event.target.value != '' && !element.querySelector('input')?.value?.toLowerCase()?.includes(event.target.value.toLowerCase())) {
          element.setAttribute('hidden', '');
        } else {
          const text = element.querySelector("label > span:first-child").innerHTML;
          const newText = text.replace(new RegExp(event.target.value, "gi"), (str) => `<mark>${str}</mark>`);
          element.querySelector("label > span:first-child").innerHTML = newText;
        }
      });
    }
    
    connectedCallback() {
      this.input.addEventListener('input', this.handleInput.bind(this));
    }
    
    disconnectedCallback() {
      this.input.removeEventListener('input', this.handleInput.bind(this));
    }
  }
  customElements.define('vendor-search', VendorSearch);
}